import React, { useState } from 'react';
import { Wrapper } from './ccGamification.styles';
import ResultTable from './components/ResultTable';
import { getGamificationPointsByQuery } from '@/API/repositories/gamificationPoints';
import Loading from '@/common/components/Loading';
import SearchGamificationBar from './components/SearchGamificationBar';
import { useRequestsContext } from '@/common/hooks/requestHook';

const CCGamification = () => {
	const [data, setData] = useState([]);
	const { hasUnfilledRequest } = useRequestsContext();

	return (
		<Wrapper>
			{hasUnfilledRequest(getGamificationPointsByQuery) && <Loading />}
			<SearchGamificationBar setData={setData} />
			{data[0] && <ResultTable data={data} />}
		</Wrapper>
	);
};

export default CCGamification;
